export default "__VITE_ASSET__Cm2TI1IK__"